import { render, staticRenderFns } from "./RoleWiseTicketReport.vue?vue&type=template&id=15307818&"
import script from "./RoleWiseTicketReport.vue?vue&type=script&lang=js&"
export * from "./RoleWiseTicketReport.vue?vue&type=script&lang=js&"
import style0 from "./RoleWiseTicketReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports